module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "alt": "",
      "src": "image/2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub4#_idTextAnchor008"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Foreword")]), _c('span', {
    staticClass: "Normal t CharOverride-1"
  }, [_vm._v(" by Marie Lupo Nygren ")])]), _c('span', {
    staticClass: "Normal t CharOverride-1"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-8"
  }), _c('span', {
    staticClass: "Normal t CharOverride-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub5#_idTextAnchor025"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Introduction")])]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-9"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub6#_idTextAnchor053"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Appetizers")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" / History")])]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-9"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub7#_idTextAnchor120"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Beef, Pork & Poultry")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" / Margaret Lupo")])]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-9"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub8#_idTextAnchor206"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Bread & Beverages ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("/ New Owners  ")])]), _c('span', {
    staticClass: "recipe-title CharOverride-9"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub9#_idTextAnchor268"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Seafood")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" / Our Customers")])]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-9"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub10#_idTextAnchor336"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Pickles & Canning")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" / Our Staff")])]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-10"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub11#_idTextAnchor370"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Sides")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" / In the Kitchen   ")])]), _c('span', {
    staticClass: "recipe-title CharOverride-10"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub12#_idTextAnchor432"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Desserts")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" / Kudos \t")])]), _c('span', {
    staticClass: "recipe-title CharOverride-10"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub13#_idTextAnchor489"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Index")])]), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-10"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub14#_idTextAnchor492"
    }
  }, [_c('span', {
    staticClass: "recipe-title CharOverride-7"
  }, [_vm._v("Acknowledgments")])]), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-10"
  }), _c('span', {
    staticClass: "recipe-title CharOverride-7"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1829c795","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mary_Mac_Final_epub-3.vue
// module id = 66
// module chunks = 0